import { defineExperiment } from '@cian/experiments/ab';
import { NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB } from '../../constants/experiments';

export const ExpOfferBookingFormModal = defineExperiment(NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
